import React, { useRef, useState } from "react";
import ReactPlayer from "react-player";

interface Props {
  repeat: boolean;
  url: string;
  handleVideoEnd?: () => void;
  width?: string;
  height?: string;
  handlePlayingChange?: (isPlaying: boolean) => void;
}

const HelpVideo = ({
  url,
  repeat,
  handleVideoEnd,
  width,
  height,
  handlePlayingChange,
}: Props) => {
  const videoRef = useRef<ReactPlayer>(null);

  const [volume, setVolume] = useState(0.5);
  const [playing, setPlaying] = useState(false);
  const [value, setValue] = useState(0);

  const handleProgress = (state: {
    played: number;
    playedSeconds: number;
    loaded: number;
    loadedSeconds: number;
  }) => {
    setValue(state.playedSeconds);
  };

  const handlePlaying = () => {
    setPlaying(true);

    if (handlePlayingChange) {
      handlePlayingChange(true);
    }
  };

  const handlePause = () => {
    setPlaying(false);

    if (handlePlayingChange) {
      handlePlayingChange(false);
    }
  };

  const handleEnd = () => {
    if (repeat) {
      if (videoRef.current) {
        videoRef.current.seekTo(0);
        setValue(0);
      }
    } else {
      handleVideoEnd && handleVideoEnd();
    }
  };

  return (
    <div>
      <ReactPlayer
        light={true}
        url={url}
        controls={true}
        ref={videoRef}
        width={"100%"}
        height={height ? height : "150px"}
        playing={playing}
        onProgress={handleProgress}
        volume={volume}
        onPlay={handlePlaying}
        onPause={handlePause}
        onEnded={handleEnd}
      />
    </div>
  );
};

export default HelpVideo;
